import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IOpenInvoice } from "../../interfaces";

export const useOpenInvoice = (enabled: boolean) => {
  return useQuery<IOpenInvoice, Error>({
    queryKey: ["billing", "open-invoice"],
    queryFn: async () => {
      return await httpService.get<IOpenInvoice>(API_CONFIG.path.billingOpenInvoice);
    },
    enabled,
  });
};
